import { Component, OnInit, ViewChild, HostListener, ElementRef, inject } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { NgClass, NgIf } from '@angular/common';

import { MenuBarComponent } from './menu-bar/menu-bar.component';
import { HeaderComponent } from './header/header.component';
import { SubscriptionStatusBannerComponent } from './subscription-status-banner/subscription-status-banner.component';
import { PreviewEnvironmentBannerComponent } from './preview-environment-banner/preview-environment-banner.component';

import { Constants } from '../core/const/constants';
import { HelperFunctionService } from '../core/services/helper-function.service';
import { OrgAppInfoHelperService } from '../core/services/org-app-info-helper.service';
import { SpinButtonService } from '../core/services/spin-button.service';
import { Subject } from 'rxjs';
import { TabSdk } from '@techextensor/tab-sdk';

@Component({
    selector: 'app-layout',
    imports: [RouterOutlet, MenuBarComponent, HeaderComponent, SubscriptionStatusBannerComponent, PreviewEnvironmentBannerComponent, NgClass, NgIf],
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss'
})
export class LayoutComponent implements OnInit {
  tenantList?: any = [];
  appList?: any = [];
  isPopupVisible: boolean = false; // Add a variable to control content visibility
  selectedTenant?: any;
  selectedAppId?: string;
  isLoading: boolean = false; // Flag to track loading state
  @ViewChild('popup') popup: ElementRef | undefined;
  private helperFunctionService: HelperFunctionService = inject(HelperFunctionService);
  private readonly orgAppInfoHelper: OrgAppInfoHelperService = inject(OrgAppInfoHelperService);
  private readonly spinButtonService: SpinButtonService = inject(SpinButtonService);
  public organizationInfo: any = {};
  public orgLogo: any;
  // private readonly router: Router = inject(Router);
  public readonly route: ActivatedRoute = inject(ActivatedRoute);
  // isPanelOpen: boolean = true;
  panelStatus: boolean = false;
  // @Output() panelOpenClose = new EventEmitter<boolean>();

  private destroy$ = new Subject<void>();

  isAdminRoute: boolean = false;

  // public favIcon: HTMLLinkElement = document.querySelector(
  //   '#appIcon'
  // ) as HTMLLinkElement;
  // private title: Title = inject(Title);
  isAppListVisible: boolean = false;
  /**
   * Initialize the component after Angular initializes the data-bound input properties.
   * The ngOnInit() method is called once, after the constructor, and immediately after the
   * first ngOnChanges().
   * It is an appropriate place to put initialization code.
   */
  ngOnInit(): void {
    this.selectedTenant = TabSdk.store.tenantId;
    this.selectedAppId = TabSdk.store.appId ?? '';
    this.organizationInfo = TabSdk.store.orgLocaleSettings;
    this.isAdminRoute = this.route?.snapshot?.data?.['routeType'] === 'Admin';

    if (this.organizationInfo?.ShowHorizontalLayout == false && this.organizationInfo?.Org_Menu_Logo) {
      this.getMenuLogo();
    }
    // Retrieve organization information from local storage
    // this.getOrgInfo();
    // this.loadTitleAndFaviconIfNeeded();
    // Fetch the list of organizations for the logged-in user
    // this.getTenantListfromLoggedInUser();
    // this.router.events
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(event => {
    //     if (event instanceof NavigationEnd) {
    //       this.updateActiveScreen();
    //     }
    //   });
  }

  /**
   * The ngOnDestroy() method is called when the component is about to be destroyed.
   * In this method, we complete the destroy$ observable to indicate that the component is no longer needed.
   */
  ngOnDestroy(): void {
    // Complete the destroy$ observable to indicate that the component is no longer needed
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMenuLogo() {
    this.orgAppInfoHelper.getDefaultAppMediaLocalUrl(this.organizationInfo?.Org_Menu_Logo)
      .subscribe((url: any) => {
        if (url) {
          this.orgLogo = url;
        }
      });
  }

  // private updateActiveScreen() {
    // let currentRoute = this.route;
    // while (currentRoute.firstChild) {
    //   currentRoute = currentRoute.firstChild;
    // }

    // const screenId = currentRoute.snapshot.paramMap.get('screenId');

    // if (screenId && screenId !== '') {
    //   if (this.panelStatus) {
    //     this.panelStatus = false;
    //     // this.panelOpenClose.emit(this.panelStatus);
    //   }
    // }
  // }

  getOrgInfo() {
    // Retrieve the 'orgInfo' key from the local storage and parse its value as JSON
    // this.organizationInfo = JSON.parse(
    //   this.localStorageService.getLocalStorage(StorageConstants.orgInfo)
    // );
  }

  public loadTitleAndFaviconIfNeeded() {
    // Set the title and favicon based on the organization name
    // if(!this.title.getTitle()){
    //   this.favIcon.href = this.organizationInfo?.FavIcon;
    //   this.title.setTitle(this.organizationInfo?.OrganizationName);
    // }
  }

  /**
   * Fetches the list of organizations for the logged-in user from the API.
   * On success, it retrieves the tenant details and hides the loader.
   */
  getTenantListfromLoggedInUser() {
    // Show loader before making the API call
    this.isLoading = true;

    // Execute the API call
    this.helperFunctionService
      .getDSQData(Constants.Get_Tenants_TABD_Tenant_Users, { Id: TabSdk.store.userId })
      .subscribe((res: any) => {
        // Check if API call is successful
        if (res && res?.Result?.length > 0) {
          // Update organization list
          this.tenantList = res.Result;
          // Fetch the list of apps for the selected tenant
          this.getAppListByTenant(this.selectedTenant);
          // Hide loader after API call completes
          this.isLoading = false;
        }
      });
  }

  /**
   * Sets the selected organization and makes an API call to fetch tenant data.
   *
   * @param tenant - The selected tenant object
   */
  getAppListByTenant(tenant: any) {
    // Show loader before making the API call
    this.isLoading = true;

    // Execute the API call to fetch tenant data
    this.helperFunctionService
      .getDSQData(Constants.Get_AppList_TenantAppUserSubscriptionsView, { TenantId: tenant })
      .subscribe((res: any) => {
        // Check if API call is successful
        if (res && res?.Result?.length > 0) {
          // Update app list
          this.appList = res.Result;
          this.showAppSwitcher();
          // Hide loader after API call completes
          this.isLoading = false;
        }
      });
  }
  showAppSwitcher() {
    this.isAppListVisible = this.tenantList?.length > 1 || (this.tenantList?.length === 1 && this.appList?.length > 1);
  }
  // /**
  //  * Sets the app ID and tenant ID in session storage and redirects to the screen.
  //  *
  //  * @param appId - The ID of the app to select
  //  */
  // async selectedApp(appId: any, tenatId: string) {
  //   // Set the app ID in session storage
  //   this.sessionStorageService.setSessionStorage(StorageConstants.AppId, appId.Id);
  //   // Set the tenant ID in session storage
  //   this.sessionStorageService.setSessionStorage(StorageConstants.TenantId, tenatId);
  //   // Set the app name in session storage
  //   this.sessionStorageService.setSessionStorage(StorageConstants.applicationCode, appId.AppName);
  //   // Load the app
  //   await this.helperFunctionService.loadApp();
  //   // Redirect to the screen
  //   window.location.pathname = '';
  // }

  /**
   * Toggles the panel open/close state.
   *
   * @param event - A boolean indicating whether the panel should be open or closed.
   */
  // panelOpenClose(event: boolean) {
  //   this.isPanelOpen = event;
  // }

  /**
   * Toggles the visibility of the popup content.
   *
   * This function toggles the visibility of the popup content by changing the value of the `isPopupVisible` property.
   * If the popup is currently visible, it will be hidden. If the popup is currently hidden, it will be shown.
   */
  toggleContentVisibility() {
    // Toggle the visibility of the popup content
    this.isPopupVisible = !this.isPopupVisible;
  }

  @HostListener('document:mousedown', ['$event'])
  /**
   * Listen for a click event on the document and check if the click was outside the notification popup.
   * If the click was outside the popup, close the popup.
   *
   * @param event - The click event.
   */
  onOutsideClick(event: any) {
    // Check if the notification popup is visible and the click is outside the popup
    if (this.isPopupVisible && this.popup && !this.popup.nativeElement.contains(event.target)) {
      this.isPopupVisible = false;
    }
  }

  public leftMenuSlide(status: boolean) {
    this.panelStatus = status;
    // this.panelOpenClose.emit(this.panelStatus);
  }

  /**
   * Window event listener for starting button spinner
   * Triggered when Formio button custom logic dispatches 'startButtonSpinner' event
   */
  @HostListener('window:startButtonSpinner', ['$event'])
  onStartButtonSpinner(event: any) {
    const instance = event?.detail?.instance;
    if (instance) {
      this.spinButtonService.handleStartSpinner(instance);
    }
  }

  /**
   * Window event listener for stopping button spinner
   * Triggered when Formio button custom logic dispatches 'stopButtonSpinner' event
   */
  @HostListener('window:stopButtonSpinner', ['$event'])
  onStopButtonSpinner(event: any) {
    const { instance, state } = event?.detail || {};
    if (instance) {
      this.spinButtonService.handleStopSpinner(instance, state);
    }
  }
}
